import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CustomerScanTable = ({ scans }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const totalPages = Math.ceil(scans?.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentScans = scans?.slice(startIndex, endIndex);

  const handleExport = () => {
    const csvContent = [
      ['Nombre', 'Cédula', 'WhatsApp', 'Fecha', 'Hora'],
      ...scans?.map(scan => [
        scan?.customerName,
        scan?.customerId,
        scan?.whatsapp,
        new Date(scan.scanDate)?.toLocaleDateString('es-CO'),
        new Date(scan.scanDate)?.toLocaleTimeString('es-CO', { hour: '2-digit', minute: '2-digit' })
      ])
    ]?.map(row => row?.join(','))?.join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL?.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `escaneos_clientes_${new Date()?.toISOString()?.split('T')?.[0]}.csv`;
    a?.click();
  };

  return (
    <div className="bg-card rounded-lg border border-border shadow-card">
      <div className="p-6 border-b border-border">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-lg font-semibold text-foreground">Registro de Escaneos</h3>
            <p className="text-sm text-muted-foreground mt-1">
              Historial completo de clientes que escanearon tu código QR
            </p>
          </div>
          <Button variant="outline" iconName="Download" onClick={handleExport}>
            Exportar CSV
          </Button>
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Cliente
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Cédula
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                WhatsApp
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Fecha
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Hora
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Membresía
              </th>
            </tr>
          </thead>
          <tbody className="bg-card divide-y divide-border">
            {currentScans?.map((scan) => (
              <tr key={scan?.id} className="hover:bg-muted/50 transition-colors">
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
                      <Icon name="User" size={20} color="var(--color-primary)" />
                    </div>
                    <span className="text-sm font-medium text-foreground">{scan?.customerName}</span>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-foreground">
                  {scan?.customerId}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <a 
                    href={`https://wa.me/57${scan?.whatsapp}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 text-sm text-success hover:underline"
                  >
                    <Icon name="MessageCircle" size={16} />
                    {scan?.whatsapp}
                  </a>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-foreground">
                  {new Date(scan.scanDate)?.toLocaleDateString('es-CO')}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-foreground">
                  {new Date(scan.scanDate)?.toLocaleTimeString('es-CO', { hour: '2-digit', minute: '2-digit' })}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium ${
                    scan?.membershipTier === 'Elite' ? 'bg-primary/10 text-primary' :
                    scan?.membershipTier === 'Emprendedor'? 'bg-accent/10 text-accent' : 'bg-muted text-muted-foreground'
                  }`}>
                    <Icon 
                      name={scan?.membershipTier === 'Elite' ? 'Crown' : scan?.membershipTier === 'Emprendedor' ? 'TrendingUp' : 'Compass'} 
                      size={12} 
                    />
                    {scan?.membershipTier}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {totalPages > 1 && (
        <div className="px-6 py-4 border-t border-border flex items-center justify-between">
          <p className="text-sm text-muted-foreground">
            Mostrando {startIndex + 1} a {Math.min(endIndex, scans?.length)} de {scans?.length} registros
          </p>
          <div className="flex items-center gap-2">
            <Button
              variant="outline"
              size="sm"
              iconName="ChevronLeft"
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(prev => prev - 1)}
            >
              Anterior
            </Button>
            <span className="text-sm text-foreground px-3">
              Página {currentPage} de {totalPages}
            </span>
            <Button
              variant="outline"
              size="sm"
              iconName="ChevronRight"
              iconPosition="right"
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage(prev => prev + 1)}
            >
              Siguiente
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomerScanTable;